import { RouteComponentProps } from '@reach/router'
import React from 'react'
import { useForm } from 'react-hook-form'
import 'twin.macro'
import { Button, Input, InputError } from '../../primitives'
import { AuthAction } from './components/AuthAction'

const links = [
  { label: 'Create An Account', href: '/register' },
  { label: 'Forgot Password', href: '/forgot-password' }
]

export const Login: React.FC<RouteComponentProps> = () => {
  const {
    handleSubmit,
    register,
    formState: { errors }
  } = useForm()
  const onSubmit = (payload: unknown) => alert(JSON.stringify(payload))

  return (
    <AuthAction title="Log in" links={links}>
      <form onSubmit={handleSubmit(onSubmit)}>
        <div tw="flex flex-col gap-3">
          <Input
            type="email"
            placeholder="E-mail"
            variant="light"
            tw="w-full"
            {...register('email', { required: true })}
          />
          <InputError error={errors.email} />
          <Input
            type="password"
            placeholder="password"
            variant="light"
            tw="w-full"
            {...register('password', { required: true })}
          />
          <InputError error={errors.password} />
          <Button type="submit" variant="primary">
            Log in
          </Button>
        </div>
      </form>
    </AuthAction>
  )
}
